module.exports = {
        srcSet: __webpack_public_path__ + "static/media/repeat-400.92571731.webp"+" 400w",
        images: [{path: __webpack_public_path__ + "static/media/repeat-400.92571731.webp",width: 400,height: 400}],
        src: __webpack_public_path__ + "static/media/repeat-400.92571731.webp",
        toString: function(){return __webpack_public_path__ + "static/media/repeat-400.92571731.webp"},
        
        width: 400,
        height: 400
      }